import { format } from 'date-fns';
import { properDate } from './dateUtilities';

const groupByDateKey = (data = [], key, fmt = 'MMM dd') => {
  return data.reduce((obj, n) => {
    const objKey = format(new Date(properDate(n[key])), fmt);
    obj[objKey] = obj[objKey] || [];
    obj[objKey].push(n);
    return obj;
  }, {});
};

export default groupByDateKey;
